export default __webpack_public_path__ + "static/media/vercel.c7601497.svg";